
const Comment = ({ username, avatar, text, time }) => {
    return (
        <div className="p-2 rounded-lg flex">
            <img className="w-8 h-8 rounded-full mr-3" src={avatar} alt={`${username}'s avatar`} />
            <div className="flex flex-col justify-between w-full">
                <div className="flex justify-between items-center w-full">
                    <span className="text-sm font-bold text-neutral-800">{username}</span>
                    <span className="text-xs text-zinc-400">{time}</span>
                </div>
                <p className="text-sm text-zinc-800 mt-1 text-left">{text}</p>
            </div>
        </div>
    );
};

export default Comment;
